



























import { Component, Prop, Vue } from "vue-property-decorator";
import { Const } from '@/const';

import Tab from './tab/tab.vue';
import DiscardConfirmation from "../alertModal/discardConfirmationModal/discardConfirmationModal.vue";
import SaveDesignModal from "../alertModal/saveDesignModal/saveDesignModal.vue";
import InsertionModal from "../alertModal/insertionModal/insertionModal.vue";
import FileOpen from '@/commonComponents/fileOpen/fileOpen.vue';
import SaveAttentionAlert from "@/commonComponents/alertModal/saveAttentionAlert/saveAttentionAlert.vue";
import SelectExcelSheetModal from "@/commonComponents/alertModal/selectExcelSheetModal/selectExcelSheetModal.vue";

// TODO document2
import { Document } from '@/model/document2/document';
import { InsertionData } from '@/model/document2/insertionData/insertionData';
import { Page } from '@/model/document2/page/page';
import { Design } from '@/model/document2/page/surface/design/design';
import { FileHelper } from '@/helper/fileHelper';
import { NameHelper } from '@/helper/nameHelper';
import { InsertionHelper } from '@/helper/insertionHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { NativeHelper } from '@/helper/nativeHelper';
import { DebugHelper } from '@/helper/debugHelper';
import { ExcelHelper } from '@/helper/excelHelper';
import { LogHelper } from "@/helper/logHelper";

import { NewDesignCommand } from "@/commands/newDesignCommand";

import Home from './resources/home.vue';
import Question from './resources/question.vue';
import { MessageCenter } from '@/model/messageCenter/messageCenter';

@Component({
  components: {
      Tab,
      DiscardConfirmation,
      SaveDesignModal,
      InsertionModal,
      Home,
      Question,
      FileOpen,
      SaveAttentionAlert,
      SelectExcelSheetModal
  }
})

export default class Header extends Vue {
    // 遷移元
    @Prop() private current! : string;

    // 遷移元から抜けるときに完了を待つ処理
    // completion : 完了時にこれを呼び出す
    @Prop({default : null}) private onDisappear! : ((completion : () => void) => void) | null;

    // 遷移開始時に呼び出す処理
    @Prop({default : null}) private onNavigationStart! : ((link : string) => void) | null;
    // 遷移終了時に呼び出す処理
    @Prop({default : null}) private onNavigationFinish! : ((link : string) => void) | null;
    // モーダル表示時に呼び出す処理
    @Prop({default : null}) private onModalAppeared! : (() => void) | null;

    private discardConfirmationShown = false;
    private saveDesignModalShown = false;
    private insertionModalShown = false;

    // 遷移先
    private toId : number = -1;

    private get tabList() : Array<{ id : number, link : string, name : string, isSelected : boolean }>
    {
        var list : Array<{ id : number, link : string, name : string, isSelected : boolean }> = [];
        var array : Array<{ id : number, link : string, name : string }> = [];
        var flowMode = this.$store.getters.applicationState.flowMode;
        if(flowMode == 1)
        {
            array = [
                { id : 1, link : "/SelectPage", name : "用紙選択" },
                { id : 2, link : "/SelectTemplate", name : "テンプレート" },
                { id : 3, link : this.current === "/DesignEditor" ? "/DesignEditor" : "/InsertionEditor", name : "差し込み" },
                { id : 4, link : "/LayoutEditor", name : "レイアウト" },
                { id : 5, link : "/PrintSetting", name : "印刷" }
            ];
        }
        else if(flowMode == 2)
        {
            array = [
                { id : 1, link : "/SelectInsertionDesign", name : "デザイン選択" },
                { id : 2, link : this.current === "/DesignEditor" ? "/DesignEditor" : "/InsertionEditor", name : "差し込み" },
                { id : 3, link : "/LayoutEditor", name : "レイアウト" },
                { id : 4, link : "/PrintSetting", name : "印刷" }
            ];
        }
        else if(flowMode == 3)
        {
            array = [
                { id : 1, link : this.current === "/DesignEditor" ? "/DesignEditor" : "/InsertionEditor", name : "差し込み" },
                { id : 2, link : "/LayoutEditor", name : "レイアウト" },
                { id : 3, link : "/PrintSetting", name : "印刷" }
            ];
        }
        else
        {
            array = [
                { id : 1, link : "/SelectPage", name : "用紙選択" },
                { id : 2, link : "/SelectTemplate", name : "テンプレート" },
                { id : 3, link : "/DesignEditor", name : "デザイン編集" },
                { id : 4, link : "/LayoutEditor", name : "レイアウト" },
                { id : 5, link : "/PrintSetting", name : "印刷" }
            ];
        }

        // 選択状態更新
        for(var i = 0; i < array.length; ++i)
        {
            var tab = array[i];
            list.push({
                id : tab.id,
                link : tab.link,
                name : tab.name,
                isSelected : tab.link == this.current
            });
        }
        return list;
    }

    private mounted()
    {
        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);
    }

    private destroyed()
    {
        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");
    }

    // コマンド処理
    // DL版で呼び出す
    private saveModalCompletion : () => void = () => {};
    private processExecCommand(paramParent : any)
    {
        try
        {
            var command : string = paramParent.command;
            var parameter : any = paramParent.parameter;

            if(command == "save_document_completed")
            {
                // ドキュメントの保存完了をネイティブから通知される
                if(this.discardConfirmationShown || this.saveDesignModalShown)
                {
                    // 保存モーダル表示中であれば、完了処理を行う
                    this.saveModalCompletion();
                }
                // ドキュメントのハッシュ更新
                this.currentDocument.updateHash();

                // 保存履歴送信
                LogHelper.sendLog("1000", {
                    productId : this.currentDocument.productId,
                    code : this.currentDocument.paperCode,
                    templateId : this.$store.getters.data.selectedTemplate.id,
                    cloud : 0
                });
            }
            else if(command == "import_insertion_data")
            {
                // 差し込みデータ読み込み
                if(this.$router.currentRoute.path == "/InsertionEditor")
                {
                    // 差し込みがカレントの場合はheaderでの処理は不要
                    return;
                }
                if(parameter.type == "xlsx")
                {
                    // xlsx読み込み
                    let buf = parameter.data as ArrayBuffer;
                    ExcelHelper.xlsxBinaryToJsonStringWithSelectSheet(buf, (sheetNames : string[], callback : (index : number) => void) =>
                    {
                        var modal = this.$refs.selectExcelSheetModal as SelectExcelSheetModal;
                        modal.open(sheetNames, (button : string, index : number) =>
                        {
                            if(button == "ok")
                            {
                                callback(index);
                            }
                        });
                    }, (result) =>
                    {
                        this.onFileRead(result, "", "binary");
                    }, () =>
                    {
                        DebugHelper.trace("import excel error");
                    });
                }
                else if(parameter.type == "csv")
                {
                    // csv読み込み
                    let buf = parameter.data as ArrayBuffer;
                    let csv = ExcelHelper.csvBinaryToString(buf);
                    this.onFileRead(csv, "", "text");
                }
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }
    }

    public get currentDocument() : Document
    {
      	return this.$store.getters.document;
    }

    private onTabClick(id : number)
    {
        // 遷移先設定
        this.toId = id;

        if(this.onDisappear != null)
        {
            this.onDisappear(() =>
            {
                // 遷移処理
                this.processLink();
            });
        }
        else
        {
            // 遷移処理
            this.processLink();
        }
    }

    // 遷移処理
    private processLink()
    {
        // 遷移元
        var fromTab = this.getTabFromLink(this.current);
        var toTab = this.getTabFromId(this.toId);

        if(fromTab == null || toTab == null) { return; }

        // 出すべき警告
        // 0: なし
        // 1: タブでの編集内容破棄
        // 2: デザイン破棄
        // 3: 差し込みデータ要求
        // 4: 差し込みデータ要求 *デザイン選択から呼ばれた
        var alertId = 0;

        // 0: 通常
        // 1: 差し込み(テンプレートから選択)
        // 2: 差し込み(デザインから選択)
        // 3: 差し込み(ファイル読み込み)
        var flowMode = this.$store.getters.applicationState.flowMode;

        // ドキュメントのカレントデザイン
        var pageIndex = flowMode == 0 ? this.currentDocument.currentPageIndex : 0;
        var currentPage = this.currentDocument.pageList[pageIndex];
        var position = flowMode == 0 ? currentPage.currentDesignPosition : 0;
        var currentDesign = currentPage.getSurface(this.currentDocument.isReverseSurface).getDesign(position);
        // デザインにオブジェクトが存在するか？
        var hasAnyObjectDesign = currentDesign != null && currentDesign.hasAnyObject();
        // ドキュメントにオブジェクトが存在するか？
        var hasAnyObjectDocument = this.currentDocument.hasAnyObject();
        // 表にデータが存在するか？
        var hasAnyInsetionData = this.currentDocument.insertionData.hasAnyData();

        if(UserAgentHelper.isElectron())
        {
            // Electronの場合は変更フラグで確認する
            var isDocumentModified = this.currentDocument.isModified();
            hasAnyObjectDesign = isDocumentModified;
            hasAnyObjectDocument = isDocumentModified;
        }

        if(flowMode == 1)
        {
            if(fromTab.link == "/SelectPage")
            {
                // 用紙選択 ->
                if(toTab.link == "/InsertionEditor" || toTab.link == "/LayoutEditor" || toTab.link == "/PrintSetting")
                {
                    // -> 差し込み, レイアウト, 印刷
                    if(!hasAnyInsetionData) { alertId = 3; }
                }
            }
            else if(fromTab.link == "/SelectTemplate")
            {
                // テンプレート ->
                if(toTab.link == "/InsertionEditor" || toTab.link == "/LayoutEditor" || toTab.link == "/PrintSetting")
                {
                    // -> 差し込み, レイアウト, 印刷
                    if(!hasAnyInsetionData) { alertId = 3; }
                }
            }
            else if(fromTab.link == "/InsertionEditor" || fromTab.link === "/DesignEditor")
            {
                // 差し込み ->
                if(toTab.link == "/" || toTab.link == "/SelectPage" || toTab.link == "SelectTemplate")
                {
                    // -> HOME, 用紙選択, テンプレート
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
            else if(fromTab.link == "/LayoutEditor")
            {
                // レイアウト ->
                if(toTab.link == "/" || toTab.link == "/SelectPage" || toTab.link == "SelectTemplate")
                {
                    // -> HOME, 用紙選択, テンプレート
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
            else if(fromTab.link == "/PrintSetting")
            {
                // 印刷 ->
                if(toTab.link == "/" || toTab.link == "/SelectPage" || toTab.link == "SelectTemplate")
                {
                    // -> HOME, 用紙選択, テンプレート
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
        }
        else if(flowMode == 2)
        {
            if(fromTab.link == "/SelectInsertionDesign")
            {
                // デザイン選択 ->
                if(toTab.link == "/InsertionEditor" || toTab.link == "/LayoutEditor" || toTab.link == "/PrintSetting")
                {
                    // -> 差し込み、レイアウト, 印刷
                    if(!hasAnyInsetionData) { alertId = 4; }
                    // デザイン作成
                    this.createNewDesignIfNeeded();
                }
            }
            else if(fromTab.link == "/InsertionEditor")
            {
                // 差し込み ->
                if(toTab.link == "/" || toTab.link == "/SelectInsertionDesign")
                {
                    // -> HOME, デザイン選択
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
            else if(fromTab.link == "/LayoutEditor")
            {
                // レイアウト ->
                if(toTab.link == "/" || toTab.link == "/SelectInsertionDesign")
                {
                    // -> HOME, デザイン選択
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
            else if(fromTab.link == "/PrintSetting")
            {
                // 印刷 ->
                if(toTab.link == "/" || toTab.link == "/SelectInsertionDesign")
                {
                    // -> HOME, デザイン選択
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
        }
        else if(flowMode == 3)
        {
            if(fromTab.link == "/InsertionEditor")
            {
                // 差し込み ->
                if(toTab.link == "/")
                {
                    // -> HOME
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
            else if(fromTab.link == "/LayoutEditor")
            {
                // レイアウト ->
                if(toTab.link == "/")
                {
                    // -> HOME
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
            else if(fromTab.link == "/PrintSetting")
            {
                // 印刷 ->
                if(toTab.link == "/")
                {
                    // -> HOME
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
        }
        else
        {
            if(fromTab.link == "/SelectTemplate")
            {
                // テンプレート ->
                if(toTab.link == "/" || toTab.link == "/SelectPage")
                {
                    // -> HOME, 用紙選択
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
            }
            else if(fromTab.link == "/DesignEditor")
            {
                // デザイン編集 ->
                if(toTab.link == "/" || toTab.link == "/SelectPage")
                {
                    // -> HOME, 用紙選択
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
                else if(toTab.link == "/SelectTemplate")
                {
                    // -> テンプレート
                    if(hasAnyObjectDesign) { alertId = 2; }
                }
            }
            else if(fromTab.link == "/LayoutEditor")
            {
                // レイアウト ->
                if(toTab.link == "/" || toTab.link == "/SelectPage")
                {
                    // -> HOME, 用紙選択
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
                else if(toTab.link == "/SelectTemplate")
                {
                    // -> テンプレート
                    if(hasAnyObjectDesign) { alertId = 2; }
                    // デザイン作成
                    this.createNewDesignIfNeeded();
                }
                else if(toTab.link == "/DesignEditor")
                {
                    // -> デザイン編集
                    // デザイン作成
                    this.createNewDesignIfNeeded();
                }
            }
            else if(fromTab.link == "/PrintSetting")
            {
                // 印刷 ->
                if(toTab.link == "/" || toTab.link == "/SelectPage")
                {
                    // -> HOME, 用紙選択
                    if(hasAnyObjectDocument) { alertId = 1; }
                }
                else if(toTab.link == "/SelectTemplate")
                {
                    // -> テンプレート
                    if(hasAnyObjectDesign) { alertId = 2; }
                    // デザイン作成
                    this.createNewDesignIfNeeded();
                }
                else if(toTab.link == "/DesignEditor")
                {
                    // -> デザイン編集
                    // デザイン作成
                    this.createNewDesignIfNeeded();
                }
            }
        }

        if(alertId == 1)
        {
            if(this.onModalAppeared) { this.onModalAppeared(); }
            this.discardConfirmationShown = true;
        }
        else if(alertId == 2)
        {
            if(this.onModalAppeared) { this.onModalAppeared(); }
            this.saveDesignModalShown = true;
        }
        else if(alertId == 3)
        {
            if(this.onModalAppeared) { this.onModalAppeared(); }
            this.insertionModalShown = true;
        }
        else if(alertId == 4)
        {
            // デザイン選択から呼ばれた場合は、処理をデザイン選択画面に戻す
            var messageCenter = this.$store.getters.messageCenter as MessageCenter;
            messageCenter.send("to_insertion_with_design", { link : toTab.link });
        }
        else 
        {
            this.goLink(toTab.link);
        }
    }

    // 必要あれば新しいデザインを作成する
    private createNewDesignIfNeeded()
    {
        var flowMode = this.$store.getters.applicationState.flowMode;
        var pageIndex = flowMode == 0 ? this.currentDocument.currentPageIndex : 0;
        var currentPage = this.currentDocument.pageList[pageIndex];
        var position = flowMode == 0 ? currentPage.currentDesignPosition : 0;
        var currentDesign = currentPage.getSurface(this.currentDocument.isReverseSurface).getDesign(position);
        if(currentDesign == null)
        {
            // デザインを強制的に新規作成する
            var newDesignCommand = new NewDesignCommand(position, currentPage, this.currentDocument.isReverseSurface, this.currentDocument, () => {});
            this.currentDocument.undoRedoManager.do(newDesignCommand);
            if(flowMode >= 1)
            {
                this.currentDocument.undoRedoManager.init();
            }
        }
    }

    private getTabFromId(id : number)
    {
        // id == 0はHOME
        if(id == 0) { return { id : 0, link : "/", name : "HOME" }; }

        for(var i = 0; i < this.tabList.length; ++i)
        {
            var tab = this.tabList[i];
            if(tab.id == id) { return tab; }
        }

        return null;
    }

    private getTabFromLink(link : string)
    {
        // link == "/" はHOME
        if(link == "/") { return { id : 0, link : "/", name : "HOME" }; }

        for(var i = 0; i < this.tabList.length; ++i)
        {
            var tab = this.tabList[i];
            if(tab.link == link) { return tab; }
        }

        return null;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    // アラートのコールバック
    private alertCallback(button)
    {
        var toTab = this.getTabFromId(this.toId);
        if(toTab == null) { return; }

        if(button == "save")
        {
            // ファイル保存
            if(UserAgentHelper.isElectron())
            {
                // DL版は保存をネイティブで行う
                this.saveModalCompletion = () =>
                {
                    if(toTab)
                    {
                        this.goLink(toTab.link);
                    }
                };
                NativeHelper.sendNativeEvent("request_save_document", {});
            }
            else
            {
                var comp = () =>
                {
                    var document = this.currentDocument;
                    // 開いた時のファイル名があればそれを使う
                    var fileName = document.openedFileName != "" ? FileHelper.getFilenameWithoutExtension(document.openedFileName) : NameHelper.createNewDocumentFileName(document);
                    FileHelper.saveDocumentAsZip(document, fileName);
                    // 遷移
                    if(toTab != null) { this.goLink(toTab.link); }
                };

                var alert = this.$refs.saveAttentionAlert as SaveAttentionAlert;
                if(alert.isAvailable())
                {
                    // モーダルを開き、OKを押したときにセーブ
                    alert.open(comp);
                }
                else
                {
                    comp();
                }
            }
        }
        else if(button == "discard")
        {
            // ファイル破棄
            // 遷移
            this.goLink(toTab.link);
        }
        else if(button == "createInsertion")
        {
            // 表を新規作成
            // 遷移
            this.goLink(toTab.link);
        }
        else if(button == "importInsertion")
        {
            // 表を読み込む
            if(UserAgentHelper.isElectron())
            {
                // DL版は開くをネイティブで行う
                NativeHelper.sendNativeEvent("request_import_insertion_data", {});
            }
            else
            {
                var fileOpen = this.$refs.fileOpen;
                if(fileOpen != null && fileOpen instanceof FileOpen)
                {
                    fileOpen.open();
                }
            }
        }
    }

    // エクセルファイル読み込み
    private onFileRead(text : string, fileType : string, readType : string)
    {
        if(readType == "binary")
        {
            // xlsx読み込み
            var loadedData = InsertionData.createFromXlsx(text, this.currentDocument.insertionData);
            this.currentDocument.insertionData = loadedData;
        }
        else
        {
            // csv読み込み
            var loadedData = InsertionData.createFromCsv(text, this.currentDocument.insertionData);
            this.currentDocument.insertionData = loadedData;
        }

        if(this.currentDocument.insertionData.isFirstRowAsColumnName && this.currentDocument.insertionData.getRowDataCount() <= 1)
        {
            // 1行目を列名にするが有効で、行数が1の場合は行がなくなってしまうので、1行目を列名にするをオフにする
            this.currentDocument.insertionData.isFirstRowAsColumnName = false;
        }

        // カレントを 0,0 に戻す
        this.currentDocument.selectedInsertionRow = 0;
        this.currentDocument.selectedInsertionColumn = 0;
        this.currentDocument.selectedInsertionWholeColumn = -1;

        InsertionHelper.applyInsertionToFirstDesign(this.currentDocument);

        // 遷移
        var toTab = this.getTabFromId(this.toId);
        if(toTab == null) { return; }
        this.goLink(toTab.link);
    }

    // 遷移
    private goLink(link : string)
    {
        if(this.onNavigationStart != null) { this.onNavigationStart(link); }
        // 遅延実行
        setTimeout(() =>
        {
            if(this.onNavigationFinish != null) { this.onNavigationFinish(link); }
            this.$router.push(link);
        },50);
    }
}

